import sih from "../images/sih.png";
import iiit from "../images/iiit.png";

const achievements = [
  {
    id: "achievement1",
    image: sih,
    title: "Winner at SIH 2023",
    description:
      "Requirement of the problem statement was building a Domain Name Services (DNS) Filtering Service Using Threat Intelligence Feeds and AI/ML Techniques which was issued by ISRO.",
    view: "https://drive.google.com/file/d/1AVjrQBxfn74wAVbJQLbDegCNb4K0xBwA/view?usp=sharing",
  },
  {
    id: "achievement2",
    image: iiit,
    title: "Second runner-up at HackCOG IIIT DELHI",
    description:
      "Secured the 3rd rank by making a chatbot which could be used for seeking help in mental health issues. The chatbot gave human-like responses and was capable of classifying over 40 emotions based on the user's texts.",
    view: "https://drive.google.com/file/d/1AVjrQBxfn74wAVbJQLbDegCNb4K0xBwA/view?usp=sharing",
  },
];

export default achievements;
